export enum DRAWERS {
  contact = 'contact',
  immersion = 'immersion',
  mandate = 'mandate',
  user = 'user',
}
